/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2.5 8H21.5M5.99988 12H9.99988"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="3"
				width="20"
				height="18"
				rx="4"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 8H22V14.6C22 16.8402 22 17.9603 21.564 18.816C21.1805 19.5686 20.5686 20.1805 19.816 20.564C18.9603 21 17.8402 21 15.6 21H8.4C6.15979 21 5.03969 21 4.18404 20.564C3.43139 20.1805 2.81947 19.5686 2.43597 18.816C2 17.9603 2 16.8402 2 14.6V8Z"
				fill="currentColor"
			/>
			<path
				d="M2.5 8H21.5M6 12H10M8.4 21H15.6C17.8402 21 18.9603 21 19.816 20.564C20.5686 20.1805 21.1805 19.5686 21.564 18.816C22 17.9603 22 16.8402 22 14.6V9.4C22 7.15979 22 6.03968 21.564 5.18404C21.1805 4.43139 20.5686 3.81947 19.816 3.43597C18.9603 3 17.8402 3 15.6 3H8.4C6.15979 3 5.03968 3 4.18404 3.43597C3.43139 3.81947 2.81947 4.43139 2.43597 5.18404C2 6.03968 2 7.15979 2 9.4V14.6C2 16.8402 2 17.9603 2.43597 18.816C2.81947 19.5686 3.43139 20.1805 4.18404 20.564C5.03968 21 6.15979 21 8.4 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M6.05 2.25C5.3068 2.25 4.93519 2.25 4.62426 2.29925C2.91269 2.57033 1.57033 3.91269 1.29925 5.62426C1.25 5.93519 1.25 6.3068 1.25 7.05C1.25 7.2358 1.25 7.3287 1.26231 7.40643C1.33008 7.83433 1.66567 8.16992 2.09357 8.23769C2.1713 8.25 2.2642 8.25 2.45 8.25H21.55C21.7358 8.25 21.8287 8.25 21.9064 8.23769C22.3343 8.16992 22.6699 7.83433 22.7377 7.40643C22.75 7.3287 22.75 7.2358 22.75 7.05C22.75 6.3068 22.75 5.93519 22.7008 5.62426C22.4297 3.91269 21.0873 2.57033 19.3757 2.29925C19.0648 2.25 18.6932 2.25 17.95 2.25H6.05Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 11.35C1.25 10.7899 1.25 10.5099 1.35899 10.296C1.45487 10.1078 1.60785 9.95487 1.79601 9.85899C2.00992 9.75 2.28995 9.75 2.85 9.75H21.15C21.7101 9.75 21.9901 9.75 22.204 9.85899C22.3922 9.95487 22.5451 10.1078 22.641 10.296C22.75 10.5099 22.75 10.7899 22.75 11.35V15.35C22.75 17.5902 22.75 18.7103 22.314 19.566C21.9305 20.3186 21.3186 20.9305 20.566 21.314C19.7103 21.75 18.5902 21.75 16.35 21.75H7.65C5.40979 21.75 4.28969 21.75 3.43404 21.314C2.68139 20.9305 2.06947 20.3186 1.68597 19.566C1.25 18.7103 1.25 17.5902 1.25 15.35V11.35ZM5.99988 12.25C5.58566 12.25 5.24988 12.5858 5.24988 13C5.24988 13.4142 5.58566 13.75 5.99988 13.75H9.99988C10.4141 13.75 10.7499 13.4142 10.7499 13C10.7499 12.5858 10.4141 12.25 9.99988 12.25H5.99988Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14 3H14.5H15.6C17.8402 3 18.9603 3 19.816 3.43597C20.5686 3.81947 21.1805 4.43139 21.564 5.18404C22 6.03968 22 7.15979 22 9.4V14.6C22 16.8402 22 17.9603 21.564 18.816C21.1805 19.5686 20.5686 20.1805 19.816 20.564C18.9603 21 17.8402 21 15.6 21H8.4C6.15979 21 5.03968 21 4.18404 20.564C3.43139 20.1805 2.81947 19.5686 2.43597 18.816C2 17.9603 2 16.8402 2 14.6V9.4C2 7.15979 2 6.03968 2.43597 5.18404C2.81947 4.43139 3.43139 3.81947 4.18404 3.43597C5.03968 3 6.15979 3 8.4 3H9.5H10M2.5 8H18M6 12H10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2.5 8H21.5M6 12H10M8.4 21H15.6C17.8402 21 18.9603 21 19.816 20.564C20.5686 20.1805 21.1805 19.5686 21.564 18.816C22 17.9603 22 16.8402 22 14.6V9.4C22 7.15979 22 6.03968 21.564 5.18404C21.1805 4.43139 20.5686 3.81947 19.816 3.43597C18.9603 3 17.8402 3 15.6 3H8.4C6.15979 3 5.03968 3 4.18404 3.43597C3.43139 3.81947 2.81947 4.43139 2.43597 5.18404C2 6.03968 2 7.15979 2 9.4V14.6C2 16.8402 2 17.9603 2.43597 18.816C2.81947 19.5686 3.43139 20.1805 4.18404 20.564C5.03968 21 6.15979 21 8.4 21Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.25 11.35C1.25 10.7899 1.25 10.5099 1.35899 10.296C1.45487 10.1078 1.60785 9.95487 1.79601 9.85899C2.00992 9.75 2.28995 9.75 2.85 9.75H21.15C21.7101 9.75 21.9901 9.75 22.204 9.85899C22.3922 9.95487 22.5451 10.1078 22.641 10.296C22.75 10.5099 22.75 10.7899 22.75 11.35V15.35C22.75 17.5902 22.75 18.7103 22.314 19.566C21.9305 20.3186 21.3186 20.9305 20.566 21.314C19.7103 21.75 18.5902 21.75 16.35 21.75H7.65C5.40979 21.75 4.28969 21.75 3.43404 21.314C2.68139 20.9305 2.06947 20.3186 1.68597 19.566C1.25 18.7103 1.25 17.5902 1.25 15.35V11.35Z"
				fill="currentColor"
			/>
			<path
				d="M6.05 2.25C5.3068 2.25 4.93519 2.25 4.62426 2.29925C2.91269 2.57033 1.57033 3.91269 1.29925 5.62426C1.25 5.93519 1.25 6.3068 1.25 7.05C1.25 7.2358 1.25 7.3287 1.26231 7.40643C1.33008 7.83433 1.66567 8.16992 2.09357 8.23769C2.1713 8.25 2.2642 8.25 2.45 8.25H21.55C21.7358 8.25 21.8287 8.25 21.9064 8.23769C22.3343 8.16992 22.6699 7.83433 22.7377 7.40643C22.75 7.3287 22.75 7.2358 22.75 7.05C22.75 6.3068 22.75 5.93519 22.7008 5.62426C22.4297 3.91269 21.0873 2.57033 19.3757 2.29925C19.0648 2.25 18.6932 2.25 17.95 2.25H6.05Z"
				fill="currentColor"
			/>
			<path
				d="M6 12.25C5.58579 12.25 5.25 12.5858 5.25 13C5.25 13.4142 5.58579 13.75 6 13.75H10C10.4142 13.75 10.75 13.4142 10.75 13C10.75 12.5858 10.4142 12.25 10 12.25H6Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
